import { TypedPocketBase } from '../../types/pocketbase-types';
import { clean_url } from '@/utils/slug';
import { Store, UserItem } from '@/backend/store/store';

export class ClientStore extends Store {
  constructor(pb: TypedPocketBase) {
    super(pb);
  }

  async createKid({
    parent,
    name,
    banner,
    birthday,
  }: {
    parent: UserItem;
    name: string;
    birthday: Date;
    banner?: File;
  }) {
    const slug = clean_url(name);
    const data = {
      name,
      parent: parent.id,
      slug,
      banner,
      birthday: birthday.toISOString(),
    };
    const created = await this.pb.collection('kids').create(data);
    await this.pb.collection('users').update(parent.id, { ['parent_of+']: created.id });
    return created;
  }
}
